<div class="addMessage" #wrapper [ngClass]="{'addMessage--modal': isModalView}">
  <form class="addMessage__form" (ngSubmit)="onSubmit(commentMsg.value)" #commentForm [ngClass]="{hasLoader: loader}">
    <div *ngIf="isAuthenticated" class="addMessage__form__userPict">
      <vc-images
        class="addMessage__form__userPict__image"
        *ngIf="userInfo?.picture; else authorInitial"
        [url]="userInfo?.picture.path"
        [width]="60"
        [alt]="userInfo?.firstname"
      ></vc-images>
      <ng-template #authorInitial>
        <div class="addMessage__from__authorInit">{{ userInfo?.firstname | slice: 0:1 }}</div>
      </ng-template>
    </div>
    <textarea
      ngModel
      #commentMsg
      name="message"
      class="addMessage__form__input vc-inputText"
      i18n-placeholder="@@DISCUSSIONS.FORM.PLACEHOLDER"
      placeholder="Write a comment"
      rows="1"
      required
      (focus)="onFocus()"
      (ngModelChange)="resizeInput()"
    ></textarea>
    <div
      class="addMessage__form__mention"
      [ngClass]="{'addMessage__form__mention--shift': isAuthenticated}"
      i18n="@@DISCUSSIONS.FORM.INFO_MSG"
    >
      Your comment will be verified by our teams before appearing online.
    </div>
    <button
      ngSubmit
      type="submit"
      class="addMessage__form__submit vc-btn vc-btn--primary vc-btn--medium"
      [disabled]="commentMsg.value === ''"
    >
      <span class="addMessage__form__submit__text" i18n="@@DISCUSSIONS.FORM.SEND">Send</span>
      <span class="addMessage__form__submit__icon">
        <vc-sprite-icons [name]="'arrow-line-up'"></vc-sprite-icons>
      </span>
    </button>
  </form>
</div>
